<template>
  <TheFooter class="bg-teal" />
</template>
